module.exports = __webpack_public_path__ + "static/media/MIC_OFF.3caa6a31.svg";